import { Dialog } from '@material-ui/core';
import React from 'react';

import { IDNameTable } from '~/src/dash/components/tables/IDNameTable';
import { IItemIDNameRoute } from '~/src/dash/components/tables/IDNameTable/common';
import { ItemRouteType } from '~/src/dash/router/routes';

interface IProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subTitle: string;
  cypressClassName?: string;
  customFunctions?: Record<string, any>;
  data: IItemIDNameRoute[];
  type: ItemRouteType;
}

export const IDNameTableModal = ({
  open,
  onClose,
  title,
  subTitle,
  cypressClassName,
  customFunctions,
  data,
  type,
}: IProps) => {
  return (
    <Dialog fullWidth maxWidth='sm' keepMounted open={open} onClose={onClose}>
      <IDNameTable
        title={title}
        subTitle={subTitle}
        cypressClassName={cypressClassName}
        customFunctions={customFunctions}
        data={data}
        type={type}
      />
    </Dialog>
  );
};
